import { memo as Memo, useMemo } from 'react';

//* HOC
import withDataContext from 'context/consumerHOC/DataConsumer';

//* Components
import Page from 'components/common/Page';
import Collections from 'components/pages/products/Collections';

const Products = Memo(({ pages, pageParams, selectedLang }) => {
	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams]);

	return (
		<Page
			className={'about-us'}
			meta={pageData?.content?.meta}
			jsonLdType={'productCollectionList'}
			jsonLdItems={pageData?.collections}>
			{pageData && <Collections collections={pageData.collections} />}
		</Page>
	);
});

export default withDataContext(Products, ['pages']);
